<template>
  <div class="tpage">
    <div class="topbar">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/tedu')">返回</el-button>
      <span class="title">查课登记</span>
      <el-button type="text" @click="$router.push('/tedu-record')">记录</el-button>
    </div>

    <div class="body">
      <el-card class="form-card" shadow="never">
        <el-form label-position="top" @submit.native.prevent>
          <div class="row2">
            <el-form-item label="星期">
              <el-select v-model="form.week_id" placeholder="选择星期" style="width:100%">
                <el-option v-for="w in weeks" :key="w.id" :label="w.week_name" :value="w.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="节次">
              <el-select v-model="form.section_id" placeholder="选择节次" style="width:100%">
                <el-option v-for="s in sections" :key="s.id"
                           :label="s.section_name + '（' + shortTime(s.start_time) + '-' + shortTime(s.end_time) + '）'"
                           :value="s.id"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <p class="auto-tip" v-if="autoTip">
            <i class="el-icon-time"></i> {{ autoTip }}
            <el-button type="text" size="mini" @click="autoSelect">重新定位</el-button>
          </p>

          <el-form-item label="班级">
            <el-select v-model="form.school_class_id" filterable clearable
                       placeholder="输入班级名搜索,如11" style="width:100%">
              <el-option-group v-for="g in classGroups" :key="g.grade" :label="g.grade">
                <el-option v-for="c in g.items" :key="c.id" :label="className(c)" :value="c.id"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>

          <div class="row2">
            <el-form-item label="教师">
              <el-select v-model="form.teacher" filterable placeholder="输入选择教师"
                         @change="onTeacherChange" style="width:100%">
                <el-option v-for="t in teachers" :key="t.id" :label="t.name" :value="t.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程">
              <el-input v-model.trim="form.course" maxlength="10" placeholder="输入课程"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="分值">
            <el-input-number v-model="form.score" :min="-50" :max="50" :step="1" :precision="0"
                             controls-position="right" style="width:100%"></el-input-number>
          </el-form-item>

          <el-form-item label="情况说明">
            <el-input v-model.trim="form.market" type="textarea" :rows="3" maxlength="50" show-word-limit
                      placeholder="简要说明查到的情况"></el-input>
          </el-form-item>

          <el-form-item label="现场照片（最多 3 张，可不传）">
            <el-upload action="#" list-type="picture-card" :auto-upload="false" :limit="3"
                       :file-list="fileList" :on-change="onFileChange" :on-remove="onFileRemove"
                       :on-preview="onPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="block-btn" :loading="loading" @click="submit">提 交</el-button>
      </el-card>
    </div>

    <el-dialog :visible.sync="previewVisible" width="90%" custom-class="preview-dialog">
      <img :src="previewUrl" style="width:100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  eduWeeks, eduSections, eduClassList, eduTeacherList, eduAddRegister, eduUploadPicture, getTeacherLogin
} from '@/api/teacher.js'

export default {
  name: 'TeacherEduRegister',
  data() {
    return {
      weeks: [],
      sections: [],
      classes: [],
      teachers: [],
      fileList: [],
      loading: false,
      previewVisible: false,
      previewUrl: '',
      autoTip: '',
      form: {
        week_id: '',
        section_id: '',
        school_class_id: '',
        teacher: '',
        course: '',
        score: 0,
        market: ''
      }
    }
  },
  computed: {
    /** 班级按年级分组，下拉更好找 */
    classGroups() {
      const groups = []
      const index = {}
      this.classes.forEach((c) => {
        const grade = c.school_grade && c.school_grade.grade_name ? c.school_grade.grade_name : '其他'
        if (index[grade] === undefined) {
          index[grade] = groups.length
          groups.push({ grade: grade, items: [] })
        }
        groups[index[grade]].items.push(c)
      })
      return groups
    }
  },
  mounted() {
    if (!getTeacherLogin().token) {
      this.$router.replace('/tlogin')
      return
    }
    this.loadBase()
  },
  methods: {
    loadBase() {
      Promise.all([eduWeeks(), eduSections(), eduClassList(), eduTeacherList()])
        .then(([weeks, sections, classes, teachers]) => {
          this.weeks = weeks || []
          this.sections = sections || []
          this.classes = classes || []
          this.teachers = this.uniqueByName(teachers)
          this.autoSelect()
        })
        .catch(() => {
          this.$message.error('基础数据加载失败，请稍后重试')
        })
    },
    /** 教师表里可能同名不同学科，登记只存姓名，按姓名去重 */
    uniqueByName(list) {
      const seen = {}
      return (list || []).filter((t) => {
        if (!t || !t.name || seen[t.name]) return false
        seen[t.name] = true
        return true
      })
    },
    /** 选完教师后，自动带出该教师在 think_teacher_info 里的学科作为课程，可手动再改 */
    onTeacherChange(name) {
      const t = this.teachers.find((x) => x.name === name)
      if (t && t.subject) {
        this.form.course = t.subject
      }
    },
    /** 自动定位：按当前星期几 + 当前时间判断是哪一节
     *  1) 落在某节课的区间内（提前 10 分钟算作该节）→ 选该节
     *  2) 在课间/午休空档 → 选「下一节即将开始」（老师通常是提前去查课）
     *  3) 已过当天最后一节 → 选最后一节
     */
    autoSelect() {
      const now = new Date()
      let week = now.getDay()
      if (week === 0) week = 7
      if (this.weeks.some((w) => Number(w.id) === week)) {
        this.form.week_id = week
      } else if (this.weeks.length) {
        this.form.week_id = this.weeks[0].id
      }

      const secs = this.sections.slice().sort((a, b) => this.toSeconds(a.start_time) - this.toSeconds(b.start_time))
      if (!secs.length) return

      const cur = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
      let picked = null
      let state = ''

      for (let i = 0; i < secs.length; i++) {
        const s = secs[i]
        const start = this.toSeconds(s.start_time)
        const end = this.toSeconds(s.end_time)
        if (cur >= start - 600 && cur <= end) {
          // 正在上课（含提前 10 分钟的宽限）
          picked = s
          state = 'on'
          break
        }
        if (cur < start - 600) {
          // 处在上一节结束到这一节开始之间的空档 → 取即将开始的这一节
          picked = s
          state = 'next'
          break
        }
      }
      if (!picked) {
        picked = secs[secs.length - 1]
        state = 'over'
      }

      this.form.section_id = picked.id
      const weekName = (this.weeks.find((w) => Number(w.id) === week) || {}).week_name || ''
      const startText = this.shortTime(picked.start_time)
      const endText = this.shortTime(picked.end_time)
      if (state === 'on') {
        this.autoTip = '已按当前时间定位到：' + weekName + ' ' + picked.section_name + '（' + startText + '-' + endText + '）'
      } else if (state === 'next') {
        this.autoTip = '现在没有正在上的课，已定位到下一节：' + weekName + ' ' + picked.section_name + '（' + startText + ' 开始）'
      } else {
        this.autoTip = '今天课节已结束，已定位到最后一节：' + picked.section_name
      }
    },
    toSeconds(t) {
      if (!t) return 0
      const arr = String(t).split(':')
      return (Number(arr[0]) || 0) * 3600 + (Number(arr[1]) || 0) * 60 + (Number(arr[2]) || 0)
    },
    shortTime(t) {
      return t ? String(t).slice(0, 5) : ''
    },
    className(c) {
      const grade = c.school_grade && c.school_grade.grade_name ? c.school_grade.grade_name : ''
      return grade + (c.class_number != null ? c.class_number : '') + '班'
    },
    onFileChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList
    },
    onPreview(file) {
      this.previewUrl = file.url || (file.raw ? URL.createObjectURL(file.raw) : '')
      this.previewVisible = true
    },
    submit() {
      if (!this.form.week_id) {
        this.$message.warning('请选择星期')
        return
      }
      if (!this.form.section_id) {
        this.$message.warning('请选择节次')
        return
      }
      if (!this.form.school_class_id) {
        this.$message.warning('请选择班级')
        return
      }
      if (!this.form.teacher) {
        this.$message.warning('请选择教师')
        return
      }
      if (!this.form.course) {
        this.$message.warning('请输入课程')
        return
      }
      if (!Number.isInteger(this.form.score)) {
        this.$message.warning('分值必须是整数')
        return
      }
      if (!this.form.market) {
        this.$message.warning('请填写情况说明')
        return
      }

      const week = this.weeks.find((w) => w.id === this.form.week_id) || {}
      const section = this.sections.find((s) => s.id === this.form.section_id) || {}
      const cls = this.classes.find((c) => c.id === this.form.school_class_id) || {}

      const data = {
        week_id: this.form.week_id,
        section_id: this.form.section_id,
        school_class_id: this.form.school_class_id,
        week_name: week.week_name || '',
        section_name: section.section_name || '',
        class_name: this.className(cls),
        teacher: this.form.teacher,
        course: this.form.course,
        score: this.form.score,
        market: this.form.market
      }

      this.loading = true
      eduAddRegister(data)
        .then((res) => {
          if (!res || res.status !== 'success') {
            this.loading = false
            this.$message.error((res && res.message) || '提交失败')
            return
          }
          const registerId = res.data && res.data.id ? res.data.id : ''
          this.uploadPictures(registerId)
        })
        .catch(() => {
          this.loading = false
          this.$message.error('提交失败，请检查网络后重试')
        })
    },
    /** 依次上传照片，失败不影响已提交的登记 */
    uploadPictures(registerId) {
      const files = this.fileList.map((f) => f.raw).filter(Boolean)
      if (!registerId || files.length === 0) {
        this.done(files.length === 0)
        return
      }
      let failed = 0
      const tasks = files.map((file) =>
        eduUploadPicture(file, registerId).catch(() => {
          failed++
        })
      )
      Promise.all(tasks).then(() => {
        this.done(failed === 0)
      })
    },
    done(allOk) {
      this.loading = false
      if (allOk) {
        this.$message.success('提交成功')
      } else {
        this.$message.warning('登记已提交，部分照片上传失败')
      }
      this.fileList = []
      this.form.teacher = ''
      this.form.course = ''
      this.form.score = 0
      this.form.market = ''
      this.autoSelect()
      this.$router.push('/tedu-record')
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
}
.topbar {
  background: #fff;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef1f7;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}
.body {
  padding: 12px;
}
.form-card {
  border-radius: 10px;
  border: none;
  ::v-deep .el-card__body {
    padding: 16px 14px 18px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
  ::v-deep .el-form-item__label {
    padding-bottom: 2px;
    font-size: 13px;
    color: #5b6577;
    line-height: 22px;
  }
}
.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.auto-tip {
  margin: -4px 0 10px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #3b6ef0;
  background: #eef3ff;
  border-radius: 6px;

  i {
    margin-right: 2px;
  }
  ::v-deep .el-button {
    padding: 0;
    margin-left: 4px;
    font-size: 12px;
  }
}
/* 窄屏（手机竖屏）改为单列，避免下拉框标签被截断 */
@media screen and (max-width: 420px) {
  .row2 {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
.block-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  margin-top: 4px;
}
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 84px;
  height: 84px;
  line-height: 84px;
}
</style>
